import { ChangeDetectionStrategy, Component, DestroyRef, computed, effect, inject, input, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { type ParagraphModel } from '@big-direkt/utils/shared';
import { ParagraphsHostDirective } from '../../directives/paragraphs-host.directive';
import { ParagraphsComponentMapService } from '../../services/paragraphs-component-map.service';

@Component({
    selector: 'big-paragraphs-holder',
    // eslint-disable-next-line @angular-eslint/prefer-standalone
    standalone: false,
    template: '<ng-container bigDirektParagraphsHost />',
    styleUrl: './holder.component.css',
    changeDetection: ChangeDetectionStrategy.Default,
    host: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '[class]': 'classList()',
    },
})
export class HolderComponent {
    private readonly destroyRef = inject(DestroyRef);
    private readonly paragraphsComponentMapService = inject(ParagraphsComponentMapService);

    public readonly paragraphsHost = viewChild.required(ParagraphsHostDirective);

    public readonly data = input<ParagraphModel[]>();
    public readonly isEmbedded = input<boolean>(false);
    public readonly reduceSpacing = input<boolean>(false);

    public readonly classList = computed(() => {
        const isEmbedded = this.isEmbedded();
        const reduceSpacing = this.reduceSpacing();

        return `block ${isEmbedded ? 'is-embedded' : ''} ${reduceSpacing ? 'reduce-spacing' : ''}`.trim();
    });

    public constructor() {
        effect(() => {
            const data = this.data();

            if (data === undefined) {
                return;
            }

            this.paragraphsHost().viewContainerRef.clear();

            this.paragraphsComponentMapService.map(data, this.paragraphsHost()).pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
        });
    }
}
